export const PrepaymentMethods = {
  canpay: 'canpay',
  janePay: 'jane_pay',
  moneris: 'moneris',
  payfirma: 'payfirma',
  square: 'square',
  stronghold: 'stronghold',
} as const;

export type PrepaymentProviders =
  (typeof PrepaymentMethods)[keyof typeof PrepaymentMethods];

export interface Customer {
  authenticated?: boolean;
  birthDate: string;
  email: string;
  externalId: string;
  firstName: string;
  id: number | null;
  lastName: string;
  nickname: string;
  phone: string;
  promotionsOptOut?: boolean;
}

export interface PreAuthOptions {
  consents: number[] | null;
  deliveryMessage: string | null;
  fulfillmentTime: string | null;
  pickupMessage: string | null;
  pickupMode: 'pickup' | 'curbside' | null;
}
